import Chart from 'react-apexcharts';
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import coverageVerificationAnalyticService from '../../../services/coverage-verification-analytics.service';

const VerificationsByState = ({ filters }) => {
  const [verificationsByState, setVerificationsByState] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVerificationsByState = async () => {
      setError(false);
      setLoading(true);
      try {
        const data =
          await coverageVerificationAnalyticService.getVerificationsByState({
            ...filters,
          });
        setVerificationsByState(data || {});
      } catch (err) {
        console.error('Error fetching actively queried plans:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchVerificationsByState();
  }, [filters]);

  if (loading) {
    return (
      <div className="mb-3">
        <Skeleton
          height={20}
          width={220}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
        />
        <Skeleton
          height={14}
          width={160}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
          style={{ marginTop: 8 }}
        />
        <Skeleton height={280} baseColor="#dee2e6" highlightColor="#e9ecef" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-danger text-center fw-semibold">
        Failed to load actively queried plans data.
      </div>
    );
  }

  if (verificationsByState.length === 0) {
    return (
      <div className="text-muted text-center fw-semibold">
        No data available for verifications by state.
      </div>
    );
  }

  const chartOptions = {
    chart: { type: 'bar', toolbar: { show: false } },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '30%',
      },
    },
    colors: ['#8B5CF6'],
    xaxis: {
      categories: verificationsByState.map(
        (verification) => verification.stateid,
      ),
      labels: {
        style: {
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '12px',
        },
      },
      forceNiceScale: true,
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
    },
    legend: {
      show: false,
    },
  };

  const series = verificationsByState.map(
    (verification) => verification.verifications,
  );

  return (
    <Chart
      options={chartOptions}
      series={[
        {
          name: 'Verifications',
          data: series,
        },
      ]}
      type="bar"
      height={300}
    />
  );
};

export default VerificationsByState;
